import { Injectable, OnDestroy, TemplateRef } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class AppTemplateService implements OnDestroy {

    TemplateChanged = new ReplaySubject<TemplateRef<any>>();
    Template$ = this.TemplateChanged.asObservable();
    constructor() {
    }

    ngOnDestroy() {
        this.TemplateChanged.unsubscribe();
    }
}
